import { OrdersTable } from "@/components/stock/orders-table";
import type { ProjectPanelBaseProps } from "../types";

export function ProjectOrders({ projectId }: ProjectPanelBaseProps) {
	return <OrdersTable query={{ projectId }} />;
}
